import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmAction=(props)=><Dialog onClose={props.onClose}
aria-labelledby="alert-dialog-title"
aria-describedby="alert-dialog-description" open={true}
>
<DialogTitle className={props.warning?'warning':''} id="alert-dialog-title">{props.title||"Confirm Action"}</DialogTitle>
<DialogContent>
  <DialogContentText id="alert-dialog-description">
    {props.children}
  </DialogContentText>
</DialogContent>
<DialogActions>
  <Button variant="outlined" onClick={props.onConfirm} color="primary" autoFocus>
    {props.confirm||"Confirm"}
  </Button>
  <Button onClick={props.onCancel} color="primary">
    {props.cancel||"Cancel"}
  </Button>
</DialogActions>
</Dialog>;

export default ConfirmAction;